// src/services/authService.ts
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

/**
 * Cierra sesión completamente y limpia estados locales.
 */
export async function logout() {
  try {
    // Si guardás cosas en localStorage/sessionStorage, limpiarlas acá:
    // localStorage.removeItem("activeBranchId");
    // localStorage.removeItem("some-cache-key");

    await signOut(auth);
  } catch (e) {
    console.error("Error en logout:", e);
  }
}
